import { createReducer, on } from '@ngrx/store';

import {
  addGridView,
  deleteGridView,
  setGridViewType,
  storeGridViews,
  updateGridView,
} from '../actions/grid-view.actions';
import { cloneDeep } from 'lodash';

export interface GridViewState {
  gridType?: string;
  views: {
    [gridType: string]: GridView[];
  };
}

interface GridView {
  id: string;
  name: string;
  columns: string[];
}

export const initialGridViewState: GridViewState = {
  gridType: undefined,
  views: {},
};

export const gridViewFeatureKey = 'gridView';

export const gridViewReducer = createReducer(
  initialGridViewState,
  on(storeGridViews, (state, { gridType, views }) => {
    return {
      ...state,
      views: {
        ...state.views,
        [gridType]: views,
      },
    };
  }),
  on(setGridViewType, (state, { gridType }) => {
    return {
      ...state,
      gridType,
    };
  }),
  on(addGridView, (state, { gridType, view }) => ({
    ...state,
    views: {
      ...state.views,
      [gridType]: [...(state.views[gridType] ?? []), view],
    },
  })),
  on(updateGridView, (state, { gridType, view }) => {
    const updatedState = cloneDeep(state);

    if (!state.views[gridType]) {
      updatedState.views[gridType] = [view];
      return updatedState;
    }

    return {
      ...state,
      views: {
        ...state.views,
        [gridType]: state.views[gridType].map((v) =>
          v.id === view.id ? view : v,
        ),
      },
    };
  }),
  on(deleteGridView, (state, { gridType, viewId }) => ({
    ...state,
    views: {
      ...state.views,
      [gridType]: state.views[gridType].filter((v) => v.id !== viewId),
    },
  })),
);
